import type { DefecationCategoryType } from '@/types/domain/defecation/valueObjects/defecationCategory';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 排泄カテゴリ
 */
export class DefecationCategory extends PrimitiveValueObject<DefecationCategoryType> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: DefecationCategoryType): DefecationCategory {
    return new DefecationCategory(value);
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
